<template>
	<PageContainer title="Relatório administrativos">
		<div slot="header">
			<Button @handle:click="redirectToGeneral" text="Relatórios gerais" color="secondary"
				:disabled="loadingAluno || loading">
				<FileChartOutline :size="18" />
			</Button>
		</div>

		<Box space="medium">
			<form @submit.prevent="handleSubmitMonth" class="form-container">
				<div class="form-container-row">
					<div class="form-radio">
						<span>Selecione qual relatório deseja emitir</span>

						<RadioButtons :options="mesRadioOptions" name="relatorioMes" :modelValue="relatorioMes"
							@update:modelValue="$event => this.relatorioMes = $event" />
					</div>
				</div>
				<div class="form-container-row">
					<InputMonth legend="Mês" :modelValue="mes" @update:modelValue="$event => this.mes = $event" />

					<Button type="submit" text="Gerar relatório" color="primary" :disabled="loading">
						<TrayArrowDown :size="18" />
					</Button>
				</div>
			</form>
		</Box>

		<Box space="medium">
			<form @submit.prevent="handleSubmitPeriod" class="form-container">
				<div class="form-container-row">
					<div class="form-radio">
						<span>Selecione qual relatório deseja emitir</span>

						<RadioButtons :options="periodoRadioOptions" name="relatorioPeriodo" :modelValue="relatorioPeriodo"
							@update:modelValue="$event => this.relatorioPeriodo = $event" />
					</div>
				</div>
				<div class="form-container-row">
					<Period class="input" legend="Período" :firstModelValue="dataIni" :secondModelValue="dataFim"
						@update:firstModelValue="$event => (this.dataIni = $event)"
						@update:secondModelValue="$event => (this.dataFim = $event)" :disabled="loading" />

					<Button type="submit" text="Gerar relatório" color="primary" :disabled="loading">
						<TrayArrowDown :size="18" />
					</Button>
				</div>
			</form>
		</Box>

		<Box space="medium">
			<form @submit.prevent="handleSubmitNoFilters" class="form-container">
				<div class="form-container-row">
					<div class="form-radio">
						<span>Selecione qual relatório deseja emitir</span>

						<RadioButtons :options="noFilterRadioOptions" name="relatorioSemFiltro" :modelValue="relatorioSemFiltro"
							@update:modelValue="$event => this.relatorioSemFiltro = $event" />
					</div>
				</div>
				<div class="form-container-row">
					<Button type="submit" text="Gerar relatório" color="primary" :disabled="loadingAluno || loading">
						<TrayArrowDown :size="18" />
					</Button>
				</div>
			</form>
		</Box>

		<Box space="medium">
			<form @submit.prevent="handleSubmitCommissions" class="form-container">
				<div class="form-container-row">
					<span>Comissões</span>
				</div>
				<div class="form-container-row">
					<Select :options="consultoresOptions" legend="Consultor" placeholder="Digite o nome do consultor"
						:modelValue="consultor" @update:modelValue="$event => (this.consultor = $event)"
						:disabled="loadingConsultor || loading" />

					<InputMonth legend="Mês" :modelValue="mesComissao" @update:modelValue="$event => this.mesComissao = $event" />

					<Button type="submit" text="Gerar relatório" color="primary" :disabled="loadingConsultor || loading">
						<TrayArrowDown :size="18" />
					</Button>
				</div>
			</form>
		</Box>

		<Box space="medium">
			<form @submit.prevent="handleSubmitStudentsRegistered" class="form-container">
				<div class="form-container-row">
					<span>Alunos cadastrados</span>
				</div>
				<div class="form-container-row">
					<Select :options="cfcsOptions" legend="Autoescola" placeholder="Selecione uma autoescola" :modelValue="cfc"
						@update:modelValue="$event => (this.cfc = $event)" :disabled="loadingCfc || loading" />

					<Period legend="Período" :firstModelValue="dataIniAluno" :secondModelValue="dataFimAluno"
						@update:firstModelValue="$event => (this.dataIniAluno = $event)"
						@update:secondModelValue="$event => (this.dataFimAluno = $event)" :disabled="loadingCfc || loading" />

					<Button type="submit" text="Gerar relatório" color="primary" :disabled="loadingCfc || loading">
						<TrayArrowDown :size="18" />
					</Button>
				</div>
			</form>
		</Box>
	</PageContainer>
</template>

<script>
import * as spinners from 'epic-spinners'
import urlApi from '../../router/urlApi'
import urlApiV2 from '../../router/urlApiV2'
import _export from '../../services/export'
import PageContainer from '../core/PageContainer'
import Box from '../core/Box'
import RadioButtons from '../core/RadioButtons'
import Select from '../core/Select'
import Button from '../core/Button'
import InputMonth from '../core/InputMonth'
import Period from '../core/Period'
import TrayArrowDown from 'icons/TrayArrowDown'
import FileChartOutline from 'icons/FileChartOutline'

export default {
	name: 'relatorioAdmin',
	components: {
		...spinners,
		TrayArrowDown,
		FileChartOutline,

		PageContainer,
		Box,
		RadioButtons,
		Select,
		Button,
		Period,
		InputMonth,
	},
	data() {
		return {
			idRole: Number(localStorage.id_role),
			schema: localStorage.schema,
			mesRadioOptions: [
				{ value: "doacoes", label: "Doações" },
				{ value: "doacoesDetalhadas", label: "Doações detalhadas" },
				{ value: "faturamentoPorTipoStatus", label: "Faturamento por tipo e status" },
			],
			periodoRadioOptions: [
				{ value: "aulasPraticasTeoricas", label: "Aulas teóricas e práticas" },
				{ value: "aulasPraticasEnviadas", label: "Aulas práticas enviadas" },
				{ value: "aulasPraticasEnviadasDetalhadas", label: "Aulas práticas enviadas detalhadas" },
				{ value: "aulasTeoricasComPendencias", label: "Aulas teóricas com pendências" },
			],
			noFilterRadioOptions: [
				{ value: "boletosGerados", label: "Boletos Gerados" },
				{ value: "turmasAguardandoProcessamento", label: "Turmas Aguardando processamento" },
				{ value: "faturas", label: "Faturas" },
			],
			consultoresOptions: [],
			cfcsOptions: [],
			relatorioMes: 'doacoes',
			relatorioPeriodo: 'aulasPraticasTeoricas',
			relatorioSemFiltro: 'boletosGerados',
			mes: '',
			dataIni: '',
			dataFim: '',
			consultor: '',
			mesComissao: '',
			cfc: '',
			dataIniAluno: '',
			dataFimAluno: '',
			loading: false,
			loadingCfc: false,
			loadingAluno: false,
			loadingConsultor: false,
		}
	},
	async created() {
		const email = localStorage.email.split('@')
		const user = email[0]

		if (user !== 'admin' && user !== 'dev' && this.idRole !== 1 && this.idRole !== 2) {
			this.redirectToGeneral()
		}

		await Promise.all([
			this.getConsultores(),
			this.getCfcs(),
		])
	},
	methods: {
		async handleSubmitMonth() {
			if (this.validateInputsMonth()) {
				switch (this.relatorioMes) {
					case 'doacoes':
						await this.generateDonationsReport()
						break
					case 'doacoesDetalhadas':
						await this.generateDonationsDetailedReport()
						break
					case 'faturamentoPorTipoStatus':
						await this.generateBillingByTypeAndStatusReport()
						break
					default:
						this.toast('Tipo do relatório é inválido.')
						break
				}
			}
		},
		validateInputsMonth() {
			if (!this.relatorioMes || !this.mes) {
				this.toast('Preencha todos os campos para gerar o relatório.')
				return false
			}

			return true
		},
		async generateDonationsReport() {
			await this.reportRequest(`${urlApi}/cfc/relatorio/doacoes-por-autoescola/${this.mes}`, 'downloadPDF', 'dados', 'relatorio-doacoes')
		},
		async generateDonationsDetailedReport() {
			await this.reportRequest(`${urlApi}/cfc/relatorio/doacoes-por-autoescola-detalhadas/${this.mes}/${true}`, 'downloadCSV', 'dados', 'relatorio-doacoes-detalhado')
		},
		async generateBillingByTypeAndStatusReport() {
			await this.reportRequest(`${urlApiV2}/faturamento/exportar/faturas/tipo/status/aluno?detalhado=true&periodo=${this.mes}`, 'downloadCSV', 'dados', 'relatorio-faturamento')
		},
		async handleSubmitPeriod() {
			if (this.validateInputsPeriod()) {
				switch (this.relatorioPeriodo) {
					case 'aulasPraticasTeoricas':
						await this.generatePracticalTheoreticalClassesReport()
						break
					case 'aulasPraticasEnviadas':
						await this.generateSendPracticalClassesReport()
						break
					case 'aulasPraticasEnviadasDetalhadas':
						await this.generateSendPracticalClassesDetailedReport()
						break
					case 'aulasTeoricasComPendencias':
						await this.generatePendingTheoriesReport()
						break
					default:
						this.toast('Tipo do relatório é inválido.')
						break
				}
			}
		},
		validateInputsPeriod() {
			if (!this.relatorioPeriodo || !this.dataIni || !this.dataFim) {
				this.toast('Preencha todos os campos para gerar o relatório.')
				return false
			}

			const dataIni = new Date(this.dataIni)
			const dataFim = new Date(this.dataFim)

			if (dataIni > dataFim) {
				this.toast('A data inicial deve ser menor ou igual à data final.')
				return false
			}

			if (dataFim < dataIni) {
				this.toast('A data final deve ser maior ou igual à data inicial.')
				return false
			}

			return true
		},
		async generatePracticalTheoreticalClassesReport() {
			await Promise.all([
				this.reportRequest(`${urlApiV2}/turmas/hoje/planilha/${this.dataIni}/${this.dataFim}`, 'downloadCSV', 'dados', 'turmas-teoricas'),
				this.reportRequest(`${urlApiV2}/aulas/praticas/hoje/planilha?dataInicial=${this.dataIni}&dataFinal=${this.dataFim}`, 'downloadCSV', 'dados', 'aulas-praticas'),
			])
		},
		async generateSendPracticalClassesReport() {
			await this.reportRequest(`${urlApi}/pdf/autoescolas/aulas/praticas/${this.dataIni}/${this.dataFim}`, 'downloadPDF', 'dados', 'relatorio-aulas-praticas-enviadas')
		},
		async generateSendPracticalClassesDetailedReport() {
			await this.reportRequest(`${urlApiV2}/aulas/praticas/relatorio/praticas-detalhadas?data_i=${this.dataIni}&data_f=${this.dataFim}`, 'downloadPDF', 'dados', 'relatorio-aulas-praticas-enviadas-detalhadas')
		},
		async generatePendingTheoriesReport() {
			await this.reportRequest(`${urlApiV2}/aulas/teoricas/relatorio/teoricas-pendentes?data_i=${this.dataIni}&data_f=${this.dataFim}`, 'downloadPDF', 'data', 'relatorio-aulas-teoricas-com-pendencias')
		},
		async handleSubmitNoFilters() {
			if (this.validateInputsNoFilters()) {
				switch (this.relatorioSemFiltro) {
					case 'boletosGerados':
						await this.generateTicketsReport()
						break
					case 'turmasAguardandoProcessamento':
						await this.generateClassesAwaitingProcessingReport()
						break
					case 'faturas':
						await this.generateInvoicesReport()
						break
					default:
						this.toast('Tipo do relatório é inválido.')
						break
				}
			}
		},
		validateInputsNoFilters() {
			if (!this.relatorioSemFiltro) {
				this.toast('Escolha qual relatório deseja emitir.')
				return false
			}

			return true
		},
		async generateTicketsReport() {
			await this.reportRequest(`${urlApiV2}/boleto/relatorio/todos-boletos`, 'downloadPDF', 'dados', 'relatorio-boletos')
		},
		async generateClassesAwaitingProcessingReport() {
			await this.reportRequest(`${urlApiV2}/turmas/relatorio/teoricas/status/aguardandoprocessamento`, 'downloadPDF', 'dados', 'relatorio-turmas-aguardando-processamento')
		},
		async generateInvoicesReport() {
			await this.reportRequest(`${urlApi}/boletos/relatorio-boletos-todos-alunos`, 'downloadCSV', 'dados', 'relatorio-faturas')
		},
		async handleSubmitCommissions() {
			if (this.validateInputsCommissions()) {
				this.loading = true

				await this.$http.get(`${urlApiV2}/comissao?consultor=${this.consultor}&periodo=${this.mesComissao}`)
					.then(response => {
						_export.downloadPDF(response.body.dados, 'relatorio-comissao')
					})
					.catch(err => {
						this.toast(err.body.mensagem)
					})
					.finally(() => {
						this.loading = false
					})
			}
		},
		validateInputsCommissions() {
			if (!this.consultor || !this.mesComissao) {
				this.toast('Preencha todos os campos para gerar o relatório.')
				return false
			}

			return true
		},
		async handleSubmitStudentsRegistered() {
			if (this.validateInputsStudentsRegistered()) {
				await this.reportRequest(`${urlApiV2}/alunos/relatorio/cadastrados/${this.dataIniAluno}/${this.dataFimAluno}?schema=${this.cfc === 'all' ? '' : this.cfc}`, 'downloadCSV', 'dados', 'relatorio-alunos-cadastrados')
			}
		},
		validateInputsStudentsRegistered() {
			if (!this.cfc || !this.dataIniAluno || !this.dataFimAluno) {
				this.toast('Preencha todos os campos para gerar o relatório.')
				return false
			}

			const dataIni = new Date(this.dataIniAluno)
			const dataFim = new Date(this.dataFimAluno)

			if (dataIni > dataFim) {
				this.toast('A data inicial deve ser menor ou igual à data final.')
				return false
			}

			if (dataFim < dataIni) {
				this.toast('A data final deve ser maior ou igual à data inicial.')
				return false
			}

			return true
		},
		async reportRequest(url, type, returnData, filename) {
			this.loading = true

			await this.$http.get(url)
				.then(response => {
					_export[type](response.body[returnData], filename)
				})
				.catch(err => {
					console.log(err)
					this.toast('Erro ao gerar relatório.')
				})
				.finally(() => {
					this.loading = false
				})
		},
		async getConsultores() {
			this.loadingConsultor = true

			await this.$http.get(`${urlApiV2}/comissao/consultores`)
				.then(response => {
					this.consultoresOptions = response.body.map(consultor => ({ value: consultor.id, text: consultor.nome }))
				})
				.catch(err => {
					this.toast('Erro ao buscar consultores.')
				})
				.finally(() => {
					this.loadingConsultor = false
				})
		},
		async getCfcs() {
			this.loadingCfc = true

			await this.$http.get(`${urlApiV2}/autoescola`)
				.then(response => {
					this.cfcsOptions = [
						{ value: 'all', text: 'Todas as autoescolas' },
						...response.body.dados.map(cfc => ({
							value: cfc.tenant_schema,
							text: cfc.nome_fantasia
						}))
					]
				})
				.catch(err => {
					this.toast('Erro ao buscar autoescolas.')
				})
				.finally(() => {
					this.loadingCfc = false
				})
		},
		redirectToGeneral() {
			this.$router.push({ name: 'geral' })
		},
		toast(text) {
			this.$toasted.show(text, {
				icon: 'fa-times',
				position: 'top-right',
				duration: 5000,
				fullWidth: false
			})
		},
	},
}
</script>

<style lang="scss" scoped>
.form-container {
	display: flex;
	flex-direction: column;
	gap: 2.5rem;

	.form-container-row {
		display: flex;
		flex-wrap: wrap;
		align-items: flex-end;
		gap: 2.5rem;

		div:first-child.input {
			max-width: 38.0625rem;
			flex: 1;
		}

		>span {
			font-size: 1.25rem;
			font-weight: 600;
			color: #000;
		}

		.form-radio {
			display: flex;
			flex-direction: column;
			gap: 1rem;

			span {
				font-size: 1rem;
				font-weight: 600;
				line-height: 21.82px;
				color: #606264;
			}
		}
	}
}
</style>
